module.exports = __webpack_public_path__ + "img/202403_09.02ae22c9.jpg";